(function(){
	'Use Strict';
	angular.module('app.buildingabettercommunity')
	.controller('buildingABetterCommunityCtrl',['$scope', function($scope){
		console.log("build better");
	}]);
}());